import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Button from "components/common/Button";
import LoginButton from "components/user/LoginButton";
import { useAppDispatch, useAppSelector } from "hooks/store";
import {
  toggleCart,
  toggleDrawer,
  toggleGlobalSearchModal,
} from "store/slices/main.slice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import ReservationDialog from "./ReservationDialog";

const ToolBar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const cartLength = useAppSelector(({ main }) => main.cart.length);
  const { settings, companyData } = useAppSelector(({ main }) => main);

  const isMyOrderPage = useMemo(
    () => location.pathname === "/myOrders",
    [location.pathname]
  );

  return (
    <div className="h-[60px] px-4 sm:px-6 md:px-8 lg:px-10 flex items-center justify-between shadow-[0px_10px_10px_5px_#00000024] z-10 bg-headerbgcolor">
      <div className="flex items-center">
        {/* Mobile Menu Icon */}
        <div className="md:hidden" onClick={() => dispatch(toggleDrawer())}>
          <MenuIcon className="text-light-text cursor-pointer -ml-2" />
        </div>

        {/* Back Arrow for 'My Order' page only */}
        {isMyOrderPage && (
          <ArrowBackIcon
            className="!text-white mr-2 md:mr-5 cursor-pointer"
            onClick={() => navigate(-1)}
          />
        )}

        {/* Company Logo or Admin Icon */}
        {settings?.showLogo !== 0 ? (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white px-1.5 relative"
          >
            <img
              src={companyData?.logoUrl}
              alt=""
              className="h-10 w-10 sm:h-12 sm:w-[6.5rem] md:h-14 md:w-[6.5rem] rounded-md mr-2 md:mr-3 object-contain"
            />
          </div>
        ) : (
          <div
            onDoubleClick={() => {
              window.location.href = "/admin/setting/time";
            }}
            className="text-white px-1.5 relative"
          >
            <AdminPanelSettingsIcon className="!text-white mr-2 cursor-pointer" />
          </div>
        )}

        <div>
          {/* Company Name */}
          {!!settings.ShowCompanyName && !!companyData?.companyName && (
            <a href="/">
              <h1 className="text-lg md:text-xl font-bold text-themeSelColor ">
                {companyData?.companyName}
              </h1>
            </a>
          )}
          {!!settings.DisplayLocationOnCheckout && (
            <p className="text-sm text-center text-white">
              {companyData?.address1} {companyData?.address2}
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          className="bg-white !text-dark-text !px-1 sm:!px-2 relative"
          onClick={() => dispatch(toggleGlobalSearchModal())}
        >
          <SearchIcon className="!text-black cursor-pointer" />
        </Button>
        {/* Home Button for 'My Order' page only */}
        {isMyOrderPage && (
          <Button
            className="bg-white !text-dark-text !px-1 sm:!px-2 relative"
            onClick={() => navigate("/")}
          >
            <HomeIcon className="!text-black cursor-pointer" />
          </Button>
        )}

        {/* Login Button */}
        <LoginButton />
        {!!settings.CloseReservationOrder &&
          !!settings.ReservationOrderOptions && <ReservationDialog />}
        {/* Shopping Cart Button */}
        <Button
          className="bg-white !text-dark-text !px-1 sm:!px-2 relative"
          onClick={() => dispatch(toggleCart())}
        >
          <ShoppingCartIcon className="!text-[16px] sm:!text-[18px]" />
          {!!cartLength && (
            <div className="bg-secondary text-light-text text-[8px] sm:text-[10px] absolute h-4 w-4 sm:h-5 sm:w-5 rounded-full flex justify-center items-center -top-[5px] sm:-top-[8px] -right-[5px] sm:-right-[8px]">
              {cartLength}
            </div>
          )}
        </Button>
      </div>
    </div>
  );
};

export default ToolBar;
